import React from 'react';
import { Grid } from '@mui/material'

import Content from './content';

const EntryView = (props) => {
  return (
    <Grid container>
      <Grid item lg={3} sm={2} />
      <Grid item lg={6} sm={8} >
        <Content />
      </Grid>
    </Grid>
  );
};

export default EntryView;